var _g, _path, _path2, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 129,
    viewBox: "0 0 140 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_665_5893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.686 94.4052C107.545 83.3574 97.8206 75.0195 86.1422 75.0195C74.4637 75.0195 64.7397 83.3574 62.598 94.4052C62.1337 96.7894 64.0189 99.0003 66.4447 99.0003H105.833C108.265 99.0003 110.144 96.7963 109.679 94.4052H109.686Z",
    fill: "#FFD966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1416 69.3847C92.7178 69.3847 98.0488 64.0537 98.0488 57.4775C98.0488 50.9013 92.7178 45.5703 86.1416 45.5703C79.5654 45.5703 74.2344 50.9013 74.2344 57.4775C74.2344 64.0537 79.5654 69.3847 86.1416 69.3847Z",
    fill: "#FFD966"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.686 94.4052C107.545 83.3574 97.8206 75.0195 86.1422 75.0195C74.4637 75.0195 64.7397 83.3574 62.598 94.4052C62.1337 96.7894 64.0189 99.0003 66.4447 99.0003H105.833C108.265 99.0003 110.144 96.7963 109.679 94.4052H109.686Z",
    fill: "#FFD966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1416 69.3847C92.7178 69.3847 98.0488 64.0537 98.0488 57.4775C98.0488 50.9013 92.7178 45.5703 86.1416 45.5703C79.5654 45.5703 74.2344 50.9013 74.2344 57.4775C74.2344 64.0537 79.5654 69.3847 86.1416 69.3847Z",
    fill: "#FFD966"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_665_5893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1258 93.2401C74.4367 79.3923 62.2453 68.9336 47.6073 68.9336C32.9694 68.9336 20.778 79.3923 18.0888 93.2401C17.5066 96.2343 19.8631 98.9997 22.9127 98.9997H72.295C75.3446 98.9997 77.7011 96.2343 77.1189 93.2401H77.1258Z",
    fill: "url(#paint0_linear_665_5893)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6073 69.1069C62.088 69.1069 74.1608 79.4014 76.9149 93.0669H76.9087L76.9488 93.2732C77.5095 96.1566 75.2395 98.8264 72.295 98.8264H22.9127C19.9682 98.8264 17.6982 96.1566 18.2589 93.2732L18.2589 93.2732C20.9326 79.5052 33.0539 69.1069 47.6073 69.1069Z",
    stroke: "url(#paint1_linear_665_5893)",
    strokeWidth: 0.346543
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_665_5893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0241 61.4739C59.045 59.5808 64.0126 51.5439 62.1195 43.523C60.2264 35.5022 52.1895 30.5346 44.1686 32.4277C36.1477 34.3208 31.1802 42.3577 33.0733 50.3786C34.9664 58.3995 43.0032 63.367 51.0241 61.4739Z",
    fill: "url(#paint2_linear_665_5893)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9508 43.5628C63.822 51.4906 58.9121 59.4342 50.9843 61.3053C43.0566 63.1764 35.113 58.2665 33.2419 50.3388C31.3708 42.411 36.2807 34.4675 44.2084 32.5963C52.1362 30.7252 60.0797 35.6351 61.9508 43.5628Z",
    stroke: "url(#paint3_linear_665_5893)",
    strokeWidth: 0.346543
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_665_5893",
    x: 32.7247,
    y: 15.7676,
    width: 106.828,
    height: 113.035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.9013,
    result: "effect1_foregroundBlur_665_5893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_665_5893",
    x: 5.52446,
    y: 56.4581,
    width: 84.1586,
    height: 55.0175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.23777
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_665_5893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_665_5893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_665_5893",
    x: 20.1954,
    y: 19.5499,
    width: 54.8022,
    height: 54.8017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.23777
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_665_5893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_665_5893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665_5893",
    x1: 21.3426,
    y1: 97.3023,
    x2: 42.8772,
    y2: 54.8951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_665_5893",
    x1: 22.1794,
    y1: 71.2982,
    x2: 41.7017,
    y2: 112.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_665_5893",
    x1: 37.7538,
    y1: 62.8748,
    x2: 57.4389,
    y2: 31.0268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_665_5893",
    x1: 32.235,
    y1: 37.656,
    x2: 62.6422,
    y2: 57.8862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.b521bd48490c7660a5a6183499ff0bb0.svg";
export { ForwardRef as ReactComponent };